import { defineNuxtPlugin } from '#app'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// This plugin allows for us to skip importing font-awesome-icon
// on every file that uses it
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// would be necessary otherwise
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('font-awesome-icon', FontAwesomeIcon)
})
